/*eslint-disable no-unused-vars*/
import React from 'react';
// import Unionline from '../Line';
import Unionline from '../Line/indexCache'; // Book Cache Testing Changed
import assembleFork from '../Fork/index';
// import assembleFork from '../Fork/indexCache'; // Book Cache Testing Changed
import {
  eitherPartnerHasExs,
  getRightMostNodeObj,
  getLeftMostNodeObj,
  getSideWithLeastMultiplePartners,
  leftSideHasLessPartners,
  isUnionBelowOrEqualFocusNodeRowNrelated,
  isUnionEqualGrandParentNodeRowNrelated
} from '../../library/calc';
import { distanceBetweenNodes, nodeWidth, handleHeight, raiseHandleBy, widthBetweenAdjacentPartners, cornerBuffer} from '../../library/constants';
import { relatedColor } from '../../library/constants';

const assembleT = ({ union, nodeObjs, lineCoorsProp, unionIsRelated, centerXFromChildren, minimap, stageBackgroundCustomColor }) => {
  const { sideYPoint, start, end, unionColor } = lineCoorsProp;
  const nodeObj_1 = nodeObjs[union['p'][0]];
  const nodeObj_2 = nodeObjs[union['p'][1]];
  const malePartnerNodeObj = ( nodeObj_1.left <  nodeObj_2.left ? nodeObj_1 : nodeObj_2);
  const femalePartnerNodeObj = ( nodeObj_1.left > nodeObj_2.left ? nodeObj_2 : nodeObj_1);

  let xHandlePos = union.xHandlePos;

  const startYOfHandle = sideYPoint + 0;
  let endYOfHandle = union.forkBaseYPos;

  const fatherOfUnionIsRelated = (typeof(malePartnerNodeObj.d_r) !== 'undefined' ? true: false);
  const whichBegin = ( fatherOfUnionIsRelated ? 'end': 'start');
  const lineCoorsPropForRelated = {
    ...lineCoorsProp,
    [whichBegin]: end - ((end - xHandlePos)) + ( whichBegin === 'start' ? -cornerBuffer : +cornerBuffer),
    unionColor: relatedColor,
    // isSeparated: false,
  };

  const halflineForRelatedComponent =
    ( isUnionBelowOrEqualFocusNodeRowNrelated(union, nodeObjs) ?
      <Unionline
        {...lineCoorsPropForRelated}
        union={union}
        nodeObjs={nodeObjs}
        key={Math.random()}
        halflineForRelated={true}
        minimap={minimap}
        stageBackgroundCustomColor={stageBackgroundCustomColor}
      />
      : null
    );

  const fulllineForRelatedGrandparentsComponent =
    ( isUnionEqualGrandParentNodeRowNrelated(union, nodeObjs) ?
      <Unionline
        {...lineCoorsProp}
        union={union}
        nodeObjs={nodeObjs}
        key={Math.random()}
        fulllineForRelatedComponentGrandparents={true}
        minimap={minimap}
        stageBackgroundCustomColor={stageBackgroundCustomColor}
      />
      : null
    );

  const ForkComponentsAssembledArrayOfOne = assembleFork({
    union,
    nodeObjs,
    xHandlePos,
    startYOfHandle,
    endYOfHandle,
    unionIsRelated,
    sideYPoint,
    unionColor,
    stageBackgroundCustomColor,
  });

  let combinedComponentsArray = [
    ...[
      <Unionline
        {...lineCoorsProp}
        union={union}
        nodeObjs={nodeObjs}
        key={Math.random()}
        minimap={minimap}
        stageBackgroundCustomColor={stageBackgroundCustomColor}
      />,
      halflineForRelatedComponent,
      fulllineForRelatedGrandparentsComponent,
    ],
    ...ForkComponentsAssembledArrayOfOne
  ];
  return combinedComponentsArray;
};

export default assembleT;
